import {observable, action, computed} from 'mobx';
import _ from 'lodash';

class Docs {
  @observable loading = true;
  @observable version = 'unknown';
  @observable docs = {};

  @action setVersion(version) {
    this.version = version;
  }

  @action setDocs(docs) {
    this.loading = false;
    this.docs = docs;
  }

  @computed get isLoading() {
    return this.loading;
  }

  @computed get components() {
    return _.chain(this.docs).get('components').toArray().sortBy('displayName').value();
  }

  @computed get propsByComponent() {
    const {props} = this.docs;
    const propsByComponentId = _.groupBy(props, 'componentId');
    return propsByComponentId;
  }
}

export default new Docs();



// WEBPACK FOOTER //
// ./stores/docs.js